import { render, staticRenderFns } from "./TenantSettingsPage.vue?vue&type=template&id=3543bbf7&scoped=true&"
import script from "./TenantSettingsPage.vue?vue&type=script&lang=ts&"
export * from "./TenantSettingsPage.vue?vue&type=script&lang=ts&"
import style0 from "./TenantSettingsPage.vue?vue&type=style&index=0&id=3543bbf7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3543bbf7",
  null
  
)

export default component.exports